/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
// import { WeChatAuth } from '@jojo-design/mobile';
import request from '@woulsl/request';
import { Sentry } from '@woulsl/sentry-config';

import apimap from '../config/apimap';
import base, { DEBUG_HEADER_INFO, isJoJo, isJoJoUp, uc_switch } from '../config/base';
import { toAuthrize } from './toAuthorize';
import {
  isJoJoBrowser,
  isJoJoReadBrowser,
  isJoJoUpApp,
  jojoAppDirectLogin,
  replaceNoRighyApiBaseUrl
} from './util';

// eslint-disable-next-line import/no-named-as-default-member
const { MALL_BASE_URL } = base;

class CustomError extends Error {
  constructor({ name, message }) {
    super();
    this.name = name || 'customError';
    this.message = message || 'customErrorMessage';
  }
}

/**
 * 配置request请求时的默认参数
 */

const xhr = request.create({
  baseURL: MALL_BASE_URL,
  timeout: 30000, // 超时
  // useCache:true,//是否使用缓存
  maxCache: 100, // 最大缓存数
  // ttl:600000,//缓存时长
  prefix: '',
  // suffix:'',
  headers: {},
  credentials: 'include', // 默认请求是否带上cookie
  responseType: 'json', // 响应数据
  mode: 'cors' // same-origin|cors|no-cors|cors-with-forced-preflight
});

// 去鉴权判断
let jumpAuthStatus = false;
//

export default function (api, params = {}, options = {}) {
  const current = apimap[api] || {};
  // action
  const action = current.action || api;

  let newOptions = { ...current, ...options };
  let { baseURL: _baseURL } = newOptions;
  _baseURL = replaceNoRighyApiBaseUrl({ action, baseUrl: _baseURL })._baseUrl;
  newOptions = { ...newOptions, baseURL: _baseURL };
  // 删除为undefined情况
  if (!newOptions.baseURL) delete newOptions.baseURL;
  const hd = {};
  if (isJoJoUp) {
    hd['TM-UserAgent-appAlias'] = 'flawless';
  }

  // const userId = cookies.get('X-UAGW-userId');
  // const authMode = cookies.get('X-UAGW-authMode');
  console.log(params, '请求参数');
  const opts = {
    action,
    data: params,
    ...newOptions,
    headers: {
      //
      ...hd,
      ...(DEBUG_HEADER_INFO || {}),
      ...newOptions.headers
    }
  };

  opts.baseURL = process.env.MOCK === '1' ? '' : opts.baseURL;

  return xhr(opts)
    .then(({ data, res }) => {
      //
      const { status } = data || {};
      // console.log('xhr res', data, res);
      // cookie 失效

      const needNewOpenId = [1002].includes(status);

      if ([1001, 1005].includes(status) && !jumpAuthStatus) {
        jumpAuthStatus = true;
        // 跨租户使用链接：在非jojoup app中使用jojo的链接
        const isCorssTenant = (isJoJoReadBrowser() && isJoJoUp) || (isJoJoUpApp() && isJoJo);
        if (isJoJoBrowser() && !isCorssTenant) {
          jojoAppDirectLogin('', () => {
            jumpAuthStatus = false;
          });
          return data;
        }
        const redirectUrl = toAuthrize({
          appId: data.authWechatAppId,
          mode: 1,
          authBizType: 3
        });
        jumpAuthStatus = false;
        window.location.replace(redirectUrl);
        return data;
      }
      if (needNewOpenId && uc_switch) {
        const redirectUrl = toAuthrize({
          appId: data.authWechatAppId,
          mode: 3,
          wechatAuthType: 2
        });
        window.location.replace(redirectUrl);
      }
      //
      if (res.ok) {
        try {
          const excludeCode = [3001, 3002, 4001, 5001, 6001, 10150];
          const { resultCode, code } = data || {};
          if (
            ![1001, 1002, 1005].includes(status) &&
            resultCode !== 200 &&
            code !== 'SUCCESS' &&
            !excludeCode.includes(resultCode)
          ) {
            const err = new CustomError({ name: '接口错误', message: `${action}接口请求错误` });
            Sentry.captureException(err, {
              level: Sentry.Severity.Warning,
              extra: {
                fetch: action,
                params,
                response: data
              }
            });
          }
        } catch (error) {
          console.log(error);
        }

        //
        return data;
      }
      //
      return {};
    })
    .catch((err) => {
      console.log('请求err', err);
    });
}
